<template>
    <div class="d-none" id="clientSideValidationPixel"></div>
</template>
  
<script setup>
import { watch, computed } from 'vue';
import { mapGetters, mapMutations, mapActions } from "@/store/helper/vuex";
import { EventBus as oldEventBus } from "@/scripts/event-bus.js";
import { parsePhoneNumber, AsYouType } from 'libphonenumber-js'
import { useI18n } from 'vue-i18n';

const { checkout, formFields, fieldErrors, currentStage } = mapGetters();
const pdict = checkout || mapGetters().pdict;

const { updateFieldError } = mapMutations();
const { updateFormField, handleClientSideFieldError } = mapActions();
const { t } = useI18n();

const currentFormFieldName = computed(() => {
    return currentStage && currentStage.value === 'login' ? 'login' : currentStage && currentStage.value === 'shipping' ? 'shipping' : 'billing';
})

const activeFormFields = computed(() => {
    return formFields.value[currentFormFieldName.value];
})

const currentCountry = computed(() => {
    return activeFormFields.value.country;
})

const isHKCountry = computed(() => {
    return currentCountry.value === 'HK'
})

const currentAreaCode = computed(() => {
    return isHKCountry.value ? activeFormFields.value.postalCode : activeFormFields.value.areaCode;
})

const currentCountryBasedOnAreaCode = computed(() => {
    return (currentAreaCode.value === '1' || !currentAreaCode.value) ? currentCountry.value : pdict.value.phoneCountryCodeMap[currentAreaCode.value]
})

const currentAsYouTypeParam = computed(() => {
    return currentAreaCode.value ? currentCountryBasedOnAreaCode.value : currentCountry.value
})

//Phone Validation
let asYouTypeInstance = new AsYouType(currentAsYouTypeParam.value);

const initializeAsYouTypeInstance = watch([currentAreaCode, currentCountry], () => {
    if(currentAreaCode.value || currentCountry.value) {
        asYouTypeInstance = new AsYouType(currentAsYouTypeParam.value);
        initializeAsYouTypeInstance();
    }
}, {
    flush: 'post'
});

const reInitializeAsYouTypeInstanceOnStageChange = watch(currentStage, () => {
    asYouTypeInstance = new AsYouType(currentAsYouTypeParam.value);
    oldEventBus.$emit('phoneValidationPhoneBlur')
}, {
    flush: 'post'
});

const phoneValidationAreaCodeChange = watch([currentAreaCode, currentCountry], () => {
    asYouTypeInstance = new AsYouType(currentCountryBasedOnAreaCode.value);

    if (activeFormFields.value.phone) {
        updateFormField({
            formName: currentFormFieldName.value,
            fieldName: 'phone',
            fieldValue: asYouTypeInstance.input(activeFormFields.value.phone)
        });

        oldEventBus.$emit('phoneValidationPhoneBlur')
    }
}, {
    flush: 'post'
});

oldEventBus.$on('phoneValidationPhoneBlur', () => {
    if (!activeFormFields.value.phone || activeFormFields.value.phone && activeFormFields.value.phone.length === 0) {
        return;
    }

    if (currentCountry.value === 'CA') {
        let phoneNumberParsed = parsePhoneNumber(activeFormFields.value.phone, currentCountry.value);
        if (phoneNumberParsed.isValid() && phoneNumberParsed.country === 'US') {
            if (asYouTypeInstance.defaultCountry !== 'US') {
                asYouTypeInstance = new AsYouType('US');
            }
        } else if (asYouTypeInstance.defaultCountry !== 'CA') {
            asYouTypeInstance = new AsYouType('CA');
        }
    }

    asYouTypeInstance.reset();
    asYouTypeInstance.input(activeFormFields.value.phone);
    let phoneNumber = asYouTypeInstance.getNumber();

    if (phoneNumber && phoneNumber.isValid()) {
        if (asYouTypeInstance.country !== asYouTypeInstance.defaultCountry) {
            if (currentAreaCode.value && document.getElementById(`${currentFormFieldName.value}${isHKCountry.value ? 'ZipCode' : 'AreaCode'}`).querySelector(`option[id="${phoneNumber.countryCallingCode}"]`)) {
                updateFormField({
                    formName: currentFormFieldName.value,
                    fieldName: isHKCountry.value ? 'postalCode' : 'areaCode',
                    fieldValue: phoneNumber.countryCallingCode
                });
                return;
            } else {
                return updateFieldError({ formName: currentFormFieldName.value, fieldName: 'phone', fieldValue: t('error.message.parse.phone.profile.form') })
            }
        }
        updateFormField({
            formName: currentFormFieldName.value,
            fieldName: 'phone',
            fieldValue: phoneNumber.formatNational()
        });
        // Clearing the error
        if (fieldErrors.value[currentFormFieldName.value].phone) {
            delete fieldErrors.value[currentFormFieldName.value].phone;
        }
    } else {
        updateFieldError({ formName: currentFormFieldName.value, fieldName: 'phone', fieldValue: t('error.message.parse.phone.profile.form') });
    }

});

//Phone Validation

//Email Validation
oldEventBus.$on('emailValidationBlur', () => {
    if (!activeFormFields.value.email || activeFormFields.value.email && activeFormFields.value.email.length === 0) {
        return;
    }

    let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;

    if (regex.test(activeFormFields.value.email)) {
        delete fieldErrors.value[currentFormFieldName.value].email;
    } else {
        updateFieldError({ formName: currentFormFieldName.value, fieldName: 'email', fieldValue: t('error.message.parse.email.profile.form') })
    }
});



oldEventBus.$on('fieldValidation', (data) => {
    handleClientSideFieldError({ formName: data.FormName, field: data.field, t })
});

</script>